/* Copyright (c) Trimble Inc. All rights reserved. */

export const ANIMATION_CONSTANTS = {
    SKELETON_TYPE: 'wave',
  } as const;
  
  export const CORE_CONSTANTS = {
    MAX_CARD_IN_PAGE: 12,
  } as const;
  